import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { USERS } from "../../constants/testIds";
import { InitialsAvatar } from "../../components/shared/InitialsAvatar";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { Button } from "../../components/ui/button";
import { Plus } from "lucide-react";

export default function UsersList() {
    const [users, setUsers] = useState([]);
    const nav = useNavigate();

    useEffect(() => {
        api.get("/users").then((r) => setUsers(r.data));
    }, []);

    return (
        <div data-testid={USERS.root} className="space-y-8">
            <div className="flex items-end justify-between gap-4">
                <div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-muted mb-2">Admin</div>
                    <h1 className="font-extrabold tracking-[-0.03em] text-4xl leading-none">Users</h1>
                    <p className="text-muted mt-2 num">{users.length} seeded</p>
                </div>
                <Button
                    data-testid={USERS.newBtn}
                    onClick={() => nav("/admin/users/new")}
                    className="gap-2"
                >
                    <Plus size={16} /> New user
                </Button>
            </div>

            <div className="km-card overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="text-left">
                        <tr className="border-b border-[color:var(--km-border)] text-[11px] uppercase tracking-[0.12em] text-muted">
                            <th className="px-6 py-3 font-medium">Name</th>
                            <th className="px-6 py-3 font-medium">Role</th>
                            <th className="px-6 py-3 font-medium">Rates</th>
                            <th className="px-6 py-3 font-medium">Status</th>
                            <th className="px-6 py-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((u) => {
                            const field = u.rates?.find((r) => r.work_type_scope === "field" && !r.effective_to)?.amount;
                            const office = u.rates?.find((r) => r.work_type_scope === "office" && !r.effective_to)?.amount;
                            const all = u.rates?.find((r) => r.work_type_scope === "all" && !r.effective_to)?.amount;
                            return (
                                <tr
                                    key={u.id}
                                    data-testid={USERS.row(u.id)}
                                    className="border-b border-[color:var(--km-border)] hover:bg-[color:var(--surface-1)] cursor-pointer transition-colors"
                                    onClick={() => nav(`/admin/users/${u.id}`)}
                                >
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">
                                            <InitialsAvatar name={u.name} initials={u.initials} size={34} />
                                            <div>
                                                <div className="text-ink font-medium">{u.name}</div>
                                                <div className="text-xs text-muted">{u.email}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                        <StatusBadge status={u.role} />
                                    </td>
                                    <td className="px-6 py-4 num text-xs">
                                        {u.salaried ? (
                                            <span className="text-forest">Salaried</span>
                                        ) : (
                                            <div className="flex gap-3">
                                                {field != null && <span>Field <b className="text-ink">${field}</b></span>}
                                                {office != null && <span>Office <b className="text-ink">${office}</b></span>}
                                                {all != null && <span>All <b className="text-ink">${all}</b></span>}
                                                {field == null && office == null && all == null && (
                                                    <span className="text-muted">—</span>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                    <td className="px-6 py-4">
                                        <span className={`text-xs ${u.active ? "text-forest" : "text-muted"}`}>
                                            {u.active ? "Active" : "Disabled"}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-right text-xs text-muted">Edit →</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
